export default __webpack_public_path__ + "static/media/Cloak of Champions.554f9e01.jpg";